// Copyright ©️ 2026 eVolve MEP, LLC

import { EvolveLogo } from 'assets/images/images';

export const EvolveLogoLink = ({ disabled, color = 'white' }: { disabled?: boolean; color?: string }) =>
  disabled ? (
    <EvolveLogo color={color} title="evolve-logo" />
  ) : (
    <a
      href="https://www.evolvemep.com/"
      target="_blank"
      rel="noreferrer"
      style={{
        lineHeight: 0,
      }}
    >
      <EvolveLogo color={color} title="evolve-logo" />
    </a>
  );
